"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMDSModule = exports.handleEnergyEfficiencyClass = exports.handleMaybachClass = exports.handleClass = exports.handleBodytype = exports.handleModels = exports.handleVehicle = exports.handleImageURL = void 0;
exports.normalizeDefaultIndex = normalizeDefaultIndex;
exports.fetchVMDSEndpoint = fetchVMDSEndpoint;
const tslib_1 = require("tslib");
const vmds_1 = require("@/graphql/services/vmds");
const FcisCalculationApi_1 = tslib_1.__importDefault(require("@/services/FcisCalculationApi"));
const modules_1 = require("@/store/modules");
const utils_1 = require("@/utils");
const types_1 = require("@/store/modules/vmds/types");
const utils_2 = require("@/store/modules/vmds/utils");
const logger_1 = require("@/utils/logger");
const state = {
    availableClasses: [],
    vehicleIsReady: false,
    currentVehicle: {
        baumuster: '',
        bodytypeId: '',
        bodytypeName: '',
        brand: '',
        changeYear: '',
        className: '',
        classId: '',
        condition: '',
        consumption: {},
        currency: '',
        division: '',
        emissions: {},
        engine: {},
        engineConcept: {},
        enginePower: {},
        environmentalDiscount: '',
        fuelTypes: [],
        listPrice: 0,
        modelSeriesFacelift: false,
        modelYear: '',
        name: '',
        netPrice: 0,
        nst: '',
        stagedImgURL: '',
        subBrands: [],
        taxes: [],
        transmissionType: '',
        typeId: '',
    },
};
var VehicleCategory;
(function (VehicleCategory) {
    VehicleCategory["COMMERCIAL"] = "COMMERCIAL";
    VehicleCategory["PRIVATE"] = "PRIVATE";
})(VehicleCategory || (VehicleCategory = {}));
var ProductGroup;
(function (ProductGroup) {
    ProductGroup["PASSENGER_CAR"] = "PASSENGER_CAR";
    ProductGroup["SMART"] = "SMART";
    ProductGroup["VAN"] = "VAN";
})(ProductGroup || (ProductGroup = {}));
/**
 * Fallback for stage images
 * When not available, uses cutouts image
 * Default size is medium
 */
const handleImageURL = (images) => {
    var _a;
    const { cutouts, stage } = images;
    return stage ? `${stage}&crop=286,124,1726,1034&width=350` : (_a = cutouts === null || cutouts === void 0 ? void 0 : cutouts.medium) !== null && _a !== void 0 ? _a : '';
};
exports.handleImageURL = handleImageURL;
const handleVehicle = (vehicle) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const { combustionEngine, electricEngine } = vehicle.technicalData.engine;
    const enginePower = [];
    const mainEnginePower = (combustionEngine === null || combustionEngine === void 0 ? void 0 : combustionEngine.powerInKw) || (electricEngine === null || electricEngine === void 0 ? void 0 : electricEngine.powerInKw);
    if (mainEnginePower) {
        enginePower.push(mainEnginePower);
    }
    if (combustionEngine && electricEngine) {
        enginePower.push(electricEngine.powerInKw);
    }
    const electricEnginePower = (_a = electricEngine === null || electricEngine === void 0 ? void 0 : electricEngine.powerInKw) === null || _a === void 0 ? void 0 : _a.value;
    const combustionEnginePower = (_b = combustionEngine === null || combustionEngine === void 0 ? void 0 : combustionEngine.powerInKw) === null || _b === void 0 ? void 0 : _b.value;
    const listPrice = ((_d = (_c = vehicle.financeData) === null || _c === void 0 ? void 0 : _c.prices.manual) === null || _d === void 0 ? void 0 : _d.price) || ((_f = (_e = vehicle.financeData) === null || _e === void 0 ? void 0 : _e.prices.automatic) === null || _f === void 0 ? void 0 : _f.price);
    const netPrice = ((_h = (_g = vehicle.financeData) === null || _g === void 0 ? void 0 : _g.prices.manual) === null || _h === void 0 ? void 0 : _h.netPrice) || ((_k = (_j = vehicle.financeData) === null || _j === void 0 ? void 0 : _j.prices.automatic) === null || _k === void 0 ? void 0 : _k.netPrice);
    const discounts = ((_o = (_m = (_l = vehicle.financeData) === null || _l === void 0 ? void 0 : _l.discountPrices) === null || _m === void 0 ? void 0 : _m.manual) === null || _o === void 0 ? void 0 : _o.discounts) || ((_r = (_q = (_p = vehicle.financeData) === null || _p === void 0 ? void 0 : _p.discountPrices) === null || _q === void 0 ? void 0 : _q.automatic) === null || _r === void 0 ? void 0 : _r.discounts);
    const manufacturerEnvironmentalBonus = discounts === null || discounts === void 0 ? void 0 : discounts.find((discount) => discount.type === 'MANUFACTURER_ENVIRONMENTAL_BONUS');
    const discountAmount = manufacturerEnvironmentalBonus === null || manufacturerEnvironmentalBonus === void 0 ? void 0 : manufacturerEnvironmentalBonus.amount;
    const taxes = ((_t = (_s = vehicle.financeData) === null || _s === void 0 ? void 0 : _s.prices.manual) === null || _t === void 0 ? void 0 : _t.taxes) || ((_v = (_u = vehicle.financeData) === null || _u === void 0 ? void 0 : _u.prices.automatic) === null || _v === void 0 ? void 0 : _v.taxes);
    const validOcapiTaxesTypesLowerCase = vmds_1.validOcapiTaxesTypes.map((tax) => tax.toLowerCase());
    const filteredTaxes = taxes === null || taxes === void 0 ? void 0 : taxes.filter((tax) => {
        return validOcapiTaxesTypesLowerCase.includes(tax.name.toLowerCase());
    });
    return {
        baumuster: vehicle.baumuster,
        brand: vehicle.brand,
        ccsId: vehicle.ccsId,
        bodytypeId: vehicle.bodytypeId,
        bodytypeName: vehicle.bodytypeName,
        changeYear: vehicle.changeYear || '',
        classId: vehicle.classId,
        className: vehicle.className,
        combustionEnginePower,
        currency: (_w = vehicle.financeData) === null || _w === void 0 ? void 0 : _w.currency,
        electricEnginePower,
        engineConcept: vehicle.technicalData.engine.engineConcept,
        enginePower,
        environmentalDiscount: discountAmount,
        fuelTypes: vehicle.technicalData.engine.fuelType,
        listPrice,
        modelSeriesFacelift: vehicle.modelSeriesFacelift,
        modelYear: vehicle.modelYear,
        name: vehicle.name,
        netPrice,
        nst: vehicle.nationalSalesType,
        productGroup: vehicle.productGroup,
        stagedImgURL: (0, exports.handleImageURL)(vehicle.images),
        subBrands: vehicle.subBrands,
        taxes: filteredTaxes || [],
        technicalData: vehicle.technicalData,
        transmissionType: (_x = vehicle.technicalData.transmission) === null || _x === void 0 ? void 0 : _x.defaultTransmission,
        typeId: vehicle.typeId,
    };
};
exports.handleVehicle = handleVehicle;
const handleModels = (models, includeSubbrands) => {
    const allVehicles = [];
    models.forEach((model) => {
        model.vehicles.forEach((vehicle) => {
            var _a;
            if (includeSubbrands || !((_a = vehicle.subBrands) === null || _a === void 0 ? void 0 : _a.includes(utils_2.MAYBACH_SUBBRAND))) {
                allVehicles.push((0, exports.handleVehicle)(vehicle));
            }
        });
    });
    allVehicles === null || allVehicles === void 0 ? void 0 : allVehicles.sort((a, b) => a.listPrice - b.listPrice);
    return allVehicles;
};
exports.handleModels = handleModels;
const handleBodytype = (bodytype, includeSubbrands) => {
    const vehicles = (0, exports.handleModels)(bodytype.models, includeSubbrands);
    return {
        name: bodytype.bodytypeName,
        id: bodytype.bodytypeId,
        vehicles,
    };
};
exports.handleBodytype = handleBodytype;
const handleClass = (vehicleClass, includeSubbrands) => {
    const bodies = vehicleClass.bodytypes.map((bodytype) => (0, exports.handleBodytype)(bodytype, includeSubbrands));
    if (!bodies.length) {
        return null;
    }
    return {
        className: vehicleClass.className,
        classId: vehicleClass.classId,
        bodies,
    };
};
exports.handleClass = handleClass;
const handleMaybachClass = (classes) => {
    const bodies = [];
    classes.forEach((vehicleClass) => {
        bodies.push(...vehicleClass.bodytypes.map((bodytype) => (0, exports.handleBodytype)(bodytype, true)));
    });
    return {
        className: 'Mercedes Maybach',
        classId: 'maybach-class',
        bodies,
    };
};
exports.handleMaybachClass = handleMaybachClass;
const handleEnergyEfficiencyClass = (energyEfficiencyClass) => {
    {
        switch (energyEfficiencyClass) {
            case 'A_TRIPLE_PLUS':
                return 'A+++';
            case 'A_DOUBLE_PLUS':
                return 'A++';
            case 'A_PLUS':
                return 'A+';
            default:
                return energyEfficiencyClass;
        }
    }
};
exports.handleEnergyEfficiencyClass = handleEnergyEfficiencyClass;
function normalizeDefaultIndex(index) {
    if (index === -1) {
        return 0;
    }
    return index;
}
function fetchVMDSEndpoint(configurations) {
    var _a, _b;
    const endpoint = (_b = (_a = configurations === null || configurations === void 0 ? void 0 : configurations.vehicleMasterDataSource) === null || _a === void 0 ? void 0 : _a.endpoint) !== null && _b !== void 0 ? _b : '';
    const { VUE_APP_VMDS_ENDPOINT } = process.env;
    return VUE_APP_VMDS_ENDPOINT || endpoint;
}
const mutations = {
    SET_CLASSES: (state, data) => {
        // Freeze data and prevent Vuex from adding its getters and setters
        state.availableClasses = Object.freeze(utils_1.plsMarkets.includes(data.market) ? data.classes : (0, utils_1.avoidCarsWithNoPrice)(data.classes));
    },
    SET_VEHICLE_TECHNICAL_DATA: (state, data) => {
        state.currentVehicle = Object.assign(Object.assign({}, state.currentVehicle), data);
    },
    SET_CURRENT_VEHICLE: (state, data) => {
        state.currentVehicle = Object.freeze(data);
    },
    SET_VEHICLE_STATUS: (state, isReady) => {
        state.vehicleIsReady = isReady;
    },
};
const actions = {
    getMultipleClasses: (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ rootState, commit, dispatch }, { typeId, applicationBrand, market, }) {
        const isVans = applicationBrand === utils_1.APP_BRAND.VANS;
        try {
            const vehiclesCategory = isVans ? VehicleCategory.COMMERCIAL : VehicleCategory.PRIVATE;
            const productGroups = isVans ? [ProductGroup.VAN] : [ProductGroup.PASSENGER_CAR, ProductGroup.VAN];
            const defaultClasses = yield FcisCalculationApi_1.default.getVehicleList({
                category: vehiclesCategory,
                subBrand: null,
                productGroups: productGroups,
            });
            const combinedClasses = [...defaultClasses.map((item) => (0, exports.handleClass)(item))];
            const blacklistClasses = rootState.app.configurations.modelsBlackList;
            commit('SET_CLASSES', { classes: (0, utils_2.filterClassesByBlackList)(combinedClasses, blacklistClasses), market });
            let classIndex = 0;
            let defaultClassId = '';
            let defaultBodyTypeId;
            if (typeId) {
                combinedClasses.forEach((vehicle) => {
                    vehicle.bodies.forEach((vehicleBodies) => {
                        const vehicleTypeId = vehicleBodies.vehicles.find((vehicles) => vehicles.typeId === typeId);
                        if (vehicleTypeId) {
                            defaultClassId = vehicleTypeId.classId;
                            defaultBodyTypeId = vehicleTypeId.bodytypeId;
                        }
                    });
                });
                classIndex = normalizeDefaultIndex(combinedClasses.findIndex((vehicleClass) => vehicleClass.classId === defaultClassId));
            }
            dispatch(`${modules_1.MODULES.VEHICLE_SELECTOR}/setDefaults`, {
                vehicleClass: combinedClasses[classIndex],
                bodytypeId: defaultBodyTypeId,
                typeId,
            });
        }
        catch (e) {
            logger_1.logger.error(e);
        }
    }),
    getSingleClass: (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ commit, dispatch }, { typeId, modelSeries, subBrands, applicationBrand, engineConcept, market, }) {
        var _c, _d, _e, _f;
        try {
            const isVans = applicationBrand === utils_1.APP_BRAND.VANS;
            const vehiclesCategory = isVans ? VehicleCategory.COMMERCIAL : VehicleCategory.PRIVATE;
            const productGroups = isVans ? [ProductGroup.VAN] : [ProductGroup.PASSENGER_CAR, ProductGroup.VAN];
            const modelData = yield FcisCalculationApi_1.default.getVehicleList({
                modelSeries,
                category: vehiclesCategory,
                subBrands,
                productGroups: productGroups,
                engineConcept,
                applicationType: 'single',
            });
            const body = {
                bodytypeId: ((_c = modelData.bodytypeData) === null || _c === void 0 ? void 0 : _c.id) || '',
                bodytypeName: ((_d = modelData.bodytypeData) === null || _d === void 0 ? void 0 : _d.name) || '',
                models: [modelData],
            };
            const vehicleClass = {
                classId: ((_e = modelData.classData) === null || _e === void 0 ? void 0 : _e.id) || '',
                className: ((_f = modelData.classData) === null || _f === void 0 ? void 0 : _f.name) || '',
                bodytypes: [body],
            };
            const transformedClass = (0, exports.handleClass)(vehicleClass, true);
            commit('SET_CLASSES', { classes: [transformedClass], market });
            dispatch(`${modules_1.MODULES.VEHICLE_SELECTOR}/setDefaults`, {
                vehicleClass: transformedClass,
                typeId,
            });
        }
        catch (e) {
            logger_1.logger.error(e);
            dispatch('setAppStatus', utils_1.APP_STATUS.ERROR);
        }
    }),
    getVehicleTechnicalData: (_a, vehicle_1) => tslib_1.__awaiter(void 0, [_a, vehicle_1], void 0, function* ({ commit, dispatch }, vehicle) {
        var _b, _c, _d, _e, _f, _g;
        const { body, emissions, consumption, transmission, engine, } = vehicle.technicalData;
        const isDefaultAutomatic = transmission.defaultTransmission === types_1.Transmission.AUTOMATIC;
        const defaultBodyWeights = isDefaultAutomatic ? (_b = body === null || body === void 0 ? void 0 : body.weights) === null || _b === void 0 ? void 0 : _b.automatic : (_c = body === null || body === void 0 ? void 0 : body.weights) === null || _c === void 0 ? void 0 : _c.manual;
        let defaultEmissions = isDefaultAutomatic ? emissions === null || emissions === void 0 ? void 0 : emissions.automatic : emissions === null || emissions === void 0 ? void 0 : emissions.manual;
        const defaultConsumption = isDefaultAutomatic ? consumption === null || consumption === void 0 ? void 0 : consumption.automatic : consumption === null || consumption === void 0 ? void 0 : consumption.manual;
        const defaultWltpRange = isDefaultAutomatic
            ? (_e = (_d = engine === null || engine === void 0 ? void 0 : engine.electricEngine) === null || _d === void 0 ? void 0 : _d.wltpRange) === null || _e === void 0 ? void 0 : _e.automatic
            : (_g = (_f = engine === null || engine === void 0 ? void 0 : engine.electricEngine) === null || _f === void 0 ? void 0 : _f.wltpRange) === null || _g === void 0 ? void 0 : _g.manual;
        if (defaultEmissions) {
            defaultEmissions = Object.assign(Object.assign({}, defaultEmissions), { energyEfficiencyClass: (0, exports.handleEnergyEfficiencyClass)(defaultEmissions.energyEfficiencyClass) });
        }
        commit('SET_VEHICLE_TECHNICAL_DATA', {
            emissions: defaultEmissions,
            consumption: defaultConsumption,
            engine: {
                electricEngine: {
                    wltpRange: defaultWltpRange,
                },
                combustionEngine: Object.assign({}, engine === null || engine === void 0 ? void 0 : engine.combustionEngine),
            },
            body: Object.assign(Object.assign({}, body), { weights: defaultBodyWeights }),
        });
        commit('SET_VEHICLE_STATUS', true);
        dispatch('setAppStatus', utils_1.APP_STATUS.OK);
    }),
    selectVehicle: (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ state, commit, dispatch }, { classId, bodyTypeId, typeId, }) {
        var _c, _d;
        commit('SET_VEHICLE_STATUS', false);
        const selectedClassBodies = (_c = state.availableClasses.find((item) => item.classId === classId)) === null || _c === void 0 ? void 0 : _c.bodies;
        const selectedVehicles = (_d = selectedClassBodies === null || selectedClassBodies === void 0 ? void 0 : selectedClassBodies.find((body) => body.id === bodyTypeId)) === null || _d === void 0 ? void 0 : _d.vehicles;
        const vehicle = selectedVehicles === null || selectedVehicles === void 0 ? void 0 : selectedVehicles.find((item) => item.typeId === typeId);
        if (vehicle) {
            commit('SET_CURRENT_VEHICLE', vehicle);
            dispatch('getVehicleTechnicalData', vehicle);
        }
        else {
            logger_1.logger.error(`${classId} ${bodyTypeId} ${typeId} Failed to fetch`);
        }
    }),
};
exports.VMDSModule = {
    state,
    actions,
    mutations,
    getters: {
        availableClasses: (state) => state.availableClasses,
        currentEmissions: (state) => state.currentVehicle.emissions,
        currentEmission: (state) => state.currentVehicle.emission,
        currentConsumption: (state) => state.currentVehicle.consumption,
        currentEngine: (state) => state.currentVehicle.engine,
        currentEngineConcept: (state) => state.currentVehicle.engineConcept,
        currentFuelTypes: (state) => state.currentVehicle.fuelTypes,
        getAvailableClasses: (state) => {
            return state.availableClasses.map((item) => {
                return {
                    classId: item.classId,
                    className: item.className,
                };
            });
        },
        getBodyTypesForClass: (state) => (classId) => {
            var _a;
            return (_a = state.availableClasses.find((item) => item.classId === classId)) === null || _a === void 0 ? void 0 : _a.bodies;
        },
        getVehiclesForBodyType: (state) => (classId, bodyTypeId) => {
            var _a, _b;
            const selectedClassBodies = (_a = state.availableClasses.find((item) => item.classId === classId)) === null || _a === void 0 ? void 0 : _a.bodies;
            return (_b = selectedClassBodies.find((body) => body.id === bodyTypeId)) === null || _b === void 0 ? void 0 : _b.vehicles;
        },
        getImageForBodyType: (state) => (classId, bodyTypeId) => {
            var _a, _b;
            const selectedClassBodies = (_a = state.availableClasses.find((item) => item.classId === classId)) === null || _a === void 0 ? void 0 : _a.bodies;
            const availableVehicles = (_b = selectedClassBodies.find((body) => body.id === bodyTypeId)) === null || _b === void 0 ? void 0 : _b.vehicles;
            return availableVehicles === null || availableVehicles === void 0 ? void 0 : availableVehicles[0].stagedImgURL;
        },
        currentVehicle: (state) => state.currentVehicle,
        currentVehiclePrice: (state, rootGetters) => {
            const isBusiness = rootGetters.defaultCustomerType === utils_1.CUSTOMER_TYPE.BUSINESS;
            const priceTag = (0, utils_1.getValidPriceTag)(state.currentVehicle, isBusiness);
            return (0, utils_1.inputFormatting)(state.currentVehicle[priceTag], rootGetters.formatting);
        },
        currentVehicleTypeId: (state) => state.currentVehicle.typeId,
    },
};
